import classnames from 'classnames';
export function getThumbGlobalClassNames(_a) {
    var isMature = _a.isMature, isAntisocial = _a.isAntisocial, isDeleted = _a.isDeleted;
    return classnames('draft-thumb', 
    // the following classes are the same as what green site uses
    isMature && 'ismature', isAntisocial && 'antisocial', isDeleted && 'instorage' // this is not correct but...close enough? maybe?
    );
}
export function getSizeForFreeform(size, configuredWidth) {
    if (configuredWidth && configuredWidth < size.width) {
        var blockRatio = size.width / size.height;
        return {
            width: configuredWidth,
            height: configuredWidth / blockRatio,
        };
    }
    return size;
}
//# sourceMappingURL=helpers.js.map